const hasUpperCase = (str) => /[A-Z]/.test(str);
export default hasUpperCase;
